// Level-2 kinds: pure helpers (no React, no network), shared by lib/kinds.ts and the tests.
const isKindTag = (t: string) => t.startsWith('sub:')

/** The kind slugs a listing carries, in order. */
export const kindsOf = (tags?: readonly string[] | null): string[] => (tags ?? []).filter(isKindTag).map((t) => t.slice(4))

/** Kinds on at least `min` of these cards (the ones near them, under the current filters), most common first. */
export function kindsIn(cards: { item: { tags?: readonly string[] | null } }[], min = 2, max = 6): string[] {
  const n = new Map<string, number>()
  for (const c of cards) for (const k of kindsOf(c.item.tags)) n.set(k, (n.get(k) ?? 0) + 1)
  return [...n.entries()].filter(([, v]) => v >= min).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).slice(0, max).map(([k]) => k)
}
